import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal } from 'antd';

import { AddEditRegion } from '@totem/components/portfolio/regions/types';

const FormItem = Form.Item;

export interface Props {
  open: boolean;
  isEdit: boolean;
  region: AddEditRegion;
  loading: boolean;
  onCancel: () => void;
  onSubmit: (region: AddEditRegion) => void;
}

const AddEditRegionModal = ({
  open,
  isEdit,
  region,
  loading,
  onCancel,
  onSubmit,
}: Props) => {
  const [name, setName] = useState<string>('');
  const [nameError, setNameError] = useState<string>('');

  useEffect(() => {
    if (open) {
      setName(region.name);

      setNameError('');
    }
  }, [open, region]);

  const handleSubmit = () => {
    if (!name.trim()) {
      setNameError('Name is required.');
      return;
    }

    onSubmit({ ...region, name: name.trim() });
  };

  return (
    <Modal
      open={open}
      title={isEdit ? 'Update Region' : 'Add Region'}
      onCancel={onCancel}
      confirmLoading={loading}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          {isEdit ? 'Update' : 'Create'}
        </Button>,
      ]}
    >
      <Form layout="vertical">
        <FormItem
          label="Name"
          colon={false}
          validateStatus={nameError ? 'error' : ''}
          help={nameError || undefined}
        >
          <Input
            placeholder="Enter Region Name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            onPressEnter={handleSubmit}
            autoFocus
          />
        </FormItem>
      </Form>
    </Modal>
  );
};

export default AddEditRegionModal;
